import {
  AssistanceType,
  CommandDirection,
  CommandStatus,
  EventChangeType,
  SignalType,
} from './enums';
export const AdminStreamEvent = {
  Connected: 'connected',
  Heartbeat: 'hb',
  CommandStatus: 'command_status',
  SimulatorOnline: 'simulator_online',
  SimulatorOffline: 'simulator_offline',
  EventChanged: 'event_changed',
  AssistanceRequested: 'assistance_requested',
  AssistanceResolved: 'assistance_resolved',
  ExtensionRequested: 'extension_requested',
  ExtensionResolved: 'extension_resolved',
  SessionStarted: 'session_started',
  SessionEnded: 'session_ended',
} as const;
export type ConnectionState = 'connecting' | 'open' | 'reconnecting' | 'closed';
export interface CommandStatusChanged {
  commandId: number;
  simulatorIdentifier: string;
  companyId: number;
  type: SignalType;
  direction: CommandDirection;
  status: CommandStatus;
  detail: string | null;
  timestamp: string;
}
export interface SimulatorPresence {
  simulatorIdentifier: string;
  companyId: number;
  isOnline: boolean;
  timestamp: string;
}
export interface EventChanged {
  eventId: number;
  simulatorIdentifier: string;
  companyId: number;
  changeType: EventChangeType;
  startDateTime: string;
  endDateTime: string;
  closeActiveGame: boolean;
}
export interface AssistanceRequested {
  simulatorIdentifier: string;
  companyId: number;
  type: AssistanceType;
  requestedBy: string;
}
export interface ExtensionRequested {
  eventId: number;
  simulatorIdentifier: string;
  companyId: number;
  minutes: number;
  eventName: string;
}
export interface ExtensionResolved {
  eventId: number;
  simulatorIdentifier: string;
  companyId: number;
  approved: boolean;
  minutes: number;
  endDateTime: string;
}
export interface SessionState {
  simulatorIdentifier: string;
  companyId: number;
  eventId: number;
  timestamp: string;
}
export interface CommandResult {
  id: number;
  simulatorIdentifier: string;
  companyId: number;
  type: SignalType;
  direction: CommandDirection;
  status: CommandStatus;
  parameters: string | null;
  detail: string | null;
  expiresAt: string | null;
}
export interface SimulatorStatus {
  simulatorIdentifier: string;
  isOnline: boolean;
}
export interface PendingRequest {
  kind: 'assistance' | 'extension';
  simulatorIdentifier: string;
  companyId: number;
  eventId: number | null;
  minutes: number | null;
  eventName: string | null;
  requestedBy: string | null;
  requestedAt: string;
  expiresAt: string;
}
export interface AssistanceResolved {
  simulatorIdentifier: string;
  companyId: number;
}
export type RealtimeEventMap = {
  commandStatus: CommandStatusChanged;
  simulatorPresence: SimulatorPresence;
  eventChanged: EventChanged;
  assistanceRequested: AssistanceRequested;
  assistanceResolved: AssistanceResolved;
  extensionRequested: ExtensionRequested;
  extensionResolved: ExtensionResolved;
  sessionStarted: SessionState;
  sessionEnded: SessionState;
  connectionState: ConnectionState;
};
